import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';

/** Heads the colleagues there is no chat with yet, while searching. */
const NewChatSectionTitle = () => {
    const { i18next } = useAppContext();

    return (
        <p className="mt-3 ps-2 text-xs font-bold">
            {i18next.t('Chat.Section.Start.New')}
        </p>
    );
};

export default NewChatSectionTitle;
